import React from 'react';

const TechnologyMarquee = () => {
  const technologies = [
    { name: 'React', color: 'text-blue-400' },
    { name: 'Next.js', color: 'text-white' },
    { name: 'Node.js', color: 'text-green-500' },
    { name: 'Tailwind', color: 'text-cyan-400' },
    { name: 'Solidity', color: 'text-gray-400' },
    { name: 'Ethereum', color: 'text-purple-400' },
    { name: 'MetaMask', color: 'text-orange-400' },
    { name: 'Figma', color: 'text-pink-400' },
    { name: 'AWS', color: 'text-yellow-500' },
    { name: 'Python', color: 'text-blue-500' },
    { name: 'Flutter', color: 'text-blue-400' },
    { name: 'WordPress', color: 'text-blue-600' }
  ];

  return (
    <div className="py-12 bg-white dark:bg-slate-900 border-y dark:border-slate-800 overflow-hidden select-none">
      <div className="container mx-auto px-4 mb-8 text-center">
        <span className="text-sm font-bold uppercase tracking-widest text-gray-400 dark:text-slate-500">
          Güçlü Altyapı & Modern Teknolojiler
        </span>
      </div>
      
      <div className="relative flex overflow-hidden group py-6">
        <div className="flex animate-marquee whitespace-nowrap w-max flex-nowrap">
          {/* Double the content for a seamless loop */}
          {[...technologies, ...technologies].map((tech, i) => (
            <div key={i} className="mx-6 md:mx-12 flex items-center space-x-3 shrink-0">
              <span className={`text-xl md:text-3xl font-black ${tech.color} opacity-40 md:group-hover:opacity-100 transition-opacity duration-300 cursor-default uppercase tracking-tighter`}>
                {tech.name}
              </span>
              <span className="w-1.5 h-1.5 rounded-full bg-purple-500/20" />
            </div>
          ))}
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 20s linear infinite;
        }
        @media (max-width: 768px) {
          .animate-marquee {
            animation: marquee 15s linear infinite;
          }
        }
      `}} />
    </div>
  );
};

export default TechnologyMarquee;
